import Axios from 'axios';
import { API_HOST, axiosRequestWithAuth, axiosInstance } from './../constants/server.constant';
export const Useractivity = {
    getUserActivityData,
    getDetailsByType,
    saveUserConfig,
    getUserConfig
};

function getuserId() {
    return localStorage.getItem("userId");
}



async function getUserActivityData(fromDate, toDate) {

    return await axiosInstance.get(API_HOST + "/auditlogs/get/" + getuserId() + '?fromDate=' + formatDate(fromDate) + "&" + 'toDate=' + formatDate(toDate), axiosRequestWithAuth)
        .then(resp => {
            let returnArr = [];
            let web = [];
            let instance = [];
            for(let i = 0; i < resp.data.length; i++) {
                let data = resp.data[i];

                for(var key of Object.keys(data)) {

                    let activitylist = data[key];
                    if(activitylist.type === "instance") {
                        let d = new Date(activitylist.event_date);
                        var options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
                        let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                            second: "2-digit"
                        });


                        //let d = new Date(activitylist.event_date);
                        //let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() +' '+(d.getUTCHours()<10?'0':'')+d.getUTCHours()+':'+(d.getUTCMinutes()<10?'0':'')+d.getUTCMinutes();
                        let details = JSON.parse(activitylist.event_details);
                        //console.log(details)

                        let obj = {
                            "name": details.event_name,
                            "description": "",
                            "ipaddress": details.ipaddress,
                            "operation": details.operation,
                            "username": details.user,
                            "date": createdDate
                        };
                        instance.push(obj);
                    }
                    if(activitylist.type === "web") {

                        let d = new Date(activitylist.event_date);
                        var options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
                        let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                            second: "2-digit"
                        });
                        //let createdDate = formatDateTime(d.toUTCString().substring(4,25))
                        let details = JSON.parse(activitylist.event_details);
                        // console.log(details)
                        let obj = {
                            "name": details.event_name,
                            "description": details.event_description,
                            "ipaddress": details.ipaddress,
                            "operation": details.operation,
                            "username": details.user,
                            "date": createdDate
                        };
                        web.push(obj);
                    }
                }

            }

            returnArr.push(instance);
            returnArr.push(web);
            return returnArr;

        })
        .catch(error => {
            return false;
        });
}

async function getDetailsByType(fromDate, toDate, type) {
    return await axiosInstance.get(API_HOST + "/auditlogs/get/" + type + '/' + getuserId() + '?fromDate=' + formatDate(fromDate) + "&" + 'toDate=' + formatDate(toDate), axiosRequestWithAuth)
        .then((resp) => {

            let web = [];
            let instance = [];
            for(let i = 0; i < resp.data.length; i++) {
                let data = resp.data[i];

                for(var key of Object.keys(data)) {

                    let activitylist = data[key];
                    if(activitylist.type === "web") {
                        let d = new Date(activitylist.event_date);
                        var options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
                        let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                            second: "2-digit"
                        });
                        // let createdDate = formatDateTime(d.toUTCString().substring(4,25))
                        let details = JSON.parse(activitylist.event_details);

                        let obj = {
                            "name": details.event_name,
                            "description": details.event_description,
                            "ipaddress": details.ipaddress,
                            "operation": details.operation,
                            "username": details.user,
                            "date": createdDate
                        };
                        web.push(obj);
                    }
                    else {
                        let d = new Date(activitylist.event_date);
                        var options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
                        let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                            second: "2-digit"
                        });
                        //let createdDate = formatDateTime(d.toUTCString().substring(4,25))
                        let details = JSON.parse(activitylist.event_details);
                        let obj = {
                            "name": details.event_name,
                            "description": "",
                            "ipaddress": details.ipaddress,
                            "operation": details.operation,
                            "username": details.user,
                            "date": createdDate
                        };
                        instance.push(obj);
                    }



                }


            }

            if(type === "web") {
                return web;
            }
            else if(type === "instance")
                return instance;
        })
        .catch((err) => {
            return false;
        });
}

async function saveUserConfig(requestBody) {
    let reqHeaders = JSON.parse(JSON.stringify(axiosRequestWithAuth));
    return await axiosInstance.post('/auditlogs/' + getuserId(), requestBody, reqHeaders)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            console.log("error :" + JSON.stringify(error));
            return error;
        });
}


async function getUserConfig() {
    let reqHeaders = JSON.parse(JSON.stringify(axiosRequestWithAuth));
    return await axiosInstance.get('/auditlogs/' + getuserId(), reqHeaders)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            console.log("error :" + JSON.stringify(error));
            return error;
        });
}

function formatDateTime(date) {
    var d = new Date(date);
    var hh = d.getHours();
    var m = d.getMinutes();
    var s = d.getSeconds();
    var dd = "AM";
    var h = hh;
    if(h >= 12) {
        h = hh - 12;
        dd = "PM";
    }
    if(h == 0) {
        h = 12;
    }
    m = m < 10 ? "0" + m : m;

    s = s < 10 ? "0" + s : s;

    /* if you want 2 digit hours:
    h = h<10?"0"+h:h; */

    var pattern = new RegExp("0?" + hh + ":" + m + ":" + s);

    var replacement = h + ":" + m;
    /* if you want to add seconds
    replacement += ":"+s;  */
    replacement += " " + dd;

    return date.replace(pattern, replacement);
}
function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if(month.length < 2)
        month = '0' + month;
    if(day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}